<div class="background-gray container-fluid h-100">
  <div class="header">
    <div class="header-content">
      <div class="image-header"></div>
      <span class="text-header">Libranzas</span>
    </div>
  </div>
  <div class="container-wrap">
    <div class="col-12">
      <router-outlet name="part-center"></router-outlet>
    </div>
  </div>
  <div class="footer">
    <div class="row">
      <div class="col-xl-4 col-md-12 footer-left-content"></div>
      <div class="col-xl-8 col-md-12 footer-right-content"></div>
    </div>
  </div>
</div>
